import React from 'react';
import { Button, Grid } from '@mui/material';
import { styled } from '@mui/system';

const NumberButton = styled(Button)(({ theme, selected }) => ({
  borderRadius: '50%',
  border: `2px dashed ${selected ? theme.palette.success.main : theme.palette.primary.main}`,
  backgroundColor: selected ? theme.palette.success.main : 'white',
  color: selected ? 'white' : theme.palette.primary.main,
  minWidth: 0,
  width: '75px',
  height: '75px',
  '&:hover' : { 
    backgroundColor: selected ? theme.palette.success.main : 'white',
    color: selected ? 'white' : theme.palette.primary.main,
    border: `2px dashed ${selected ? theme.palette.success.main : theme.palette.primary.main}`,
  },
  '&:active': {
    backgroundColor: selected ? theme.palette.success.main : 'white',
    color: selected ? 'white' : theme.palette.primary.main,
    border: `2px dashed ${selected ? theme.palette.success.main : theme.palette.primary.main}`,
  },
  '&:focus' : {
    backgroundColor: selected ? theme.palette.success.main : 'white',
    color: selected ? 'white' : theme.palette.primary.main,
    border: `2px dashed ${selected ? theme.palette.success.main : theme.palette.primary.main}`,
  },
}));

function NumberGrid({ numbers, handleNumberClick, selectedIndices, inactive=false }) {
  return (
    <Grid container rowSpacing={1}>
      {numbers.map((number, index) => (
        <Grid item xs={6} key={index} sx={{minHeight: '80px'}} textAlign="center">
          {number !== null ? 
          <NumberButton
            disabled={inactive}
            disableTouchRipple
            selected={selectedIndices.includes(index)}
            onClick={() => handleNumberClick(index)}
            variant='outlined'
          >
            {number}
            </NumberButton>
          : null }
        </Grid>
      ))}
    </Grid>
  );
}

export default NumberGrid;
